import { BulkOperations } from '@openx/components-header/BulkOperations/BulkOperations';
import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton';
import { type JSX, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GetAudiencesListQuery } from '../../../../graphql/query/audiences/GetAudiencesList.generated';
import { useArchiveAudiences } from '../hooks/useArchiveAudiences';
import { useAudienceListFetch } from '../hooks/useAudienceListFetch';

type AudienceBulkOperationsProps = {
  selectedAudiences: GetAudiencesListQuery['audience'];
  closeAndUnselect: () => void;
};

export const AudienceBulkOperations = ({
  selectedAudiences,
  closeAndUnselect,
}: AudienceBulkOperationsProps): JSX.Element => {
  const { t } = useTranslation();
  const { refetch } = useAudienceListFetch();
  const { openArchiveModal, isLoading: archiveLoading } = useArchiveAudiences();

  const actions: ActionButtonProps[] = useMemo(() => {
    return [
      {
        label: t('Archive'),
        color: 'error',
        disabled: archiveLoading,
        loading: archiveLoading,
        onClick: () => {
          openArchiveModal({
            audiences: selectedAudiences,
            onSuccess: () => {
              refetch();
              closeAndUnselect();
            },
          });
        },
      },
    ];
  }, [selectedAudiences, t, archiveLoading, openArchiveModal, closeAndUnselect, refetch]);

  return <BulkOperations selectedItems={selectedAudiences} actions={actions} onClose={closeAndUnselect} />;
};
